
/**
	callback for the find function in the array prototype 
	ex: arr.find(find({a:11,b:22}))
*/

function find(elements){
	return function(item){
		var test = true; 
		for (let [key,value] of Object.entries(elements)){
			test = test && ((item[key] === value) || false  ) ; 
		}
		if (test) return item;
	}
}

export var array = { find }

